import React from 'react';
import { Link } from 'react-router-dom';
import AppDownloadSection from '../../components/AppDownloadSection/AppDownloadSection';
import { FaBullseye, FaEye, FaGem } from 'react-icons/fa';
import chefKitchenImg from '../../assets/images/chef-kitchen.jpg';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div className="container">
            <h1>ABOUT US</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>About Us</span>
            </div>
          </div>
        </div>
      </div>

      {/* Story Section */}
      <section className="about-story">
        <div className="container">
          <div className="about-story__grid">
            <div className="about-story__content">
              <span className="section-tag">Our Story</span>
              <h2 className="section-title">
                THE STORY ABOUT
                <br />
                <span>DIGIRASA</span>
              </h2>
              <p className="about-story__intro">
                Digirasa is a division of Bulusu Digital innovations Pvt. Ltd. (BDI) that focuses on
                Health stream of our product and services.
              </p>
              <div className="about-story__points">
                <div className="about-story__point">
                  <h4>WELCOME TO OUR CLOUD KITCHEN</h4>
                  <p>
                    Digirasa is a modern cloud kitchen delivering high-quality, flavorful meals with
                    speed and consistency. Designed for today's on-the-go lifestyle, it brings
                    fresh, convenient, and satisfying food straight to your doorstep.
                  </p>
                </div>
                <div className="about-story__point">
                  <h4>GENESIS</h4>
                  <p>
                    Current food industry is highly unregulated ignoring the safety and hygiene
                    standards. All the current Health indicators are showing alarming statistics.
                    Digirasa will provide healthy alternative that is hygienic, high quality
                    ingredient food that will support health and wellness of the society.
                  </p>
                </div>
              </div>
            </div>
            <div className="about-story__image">
              <img src={chefKitchenImg} alt="Digirasa Kitchen" />
            </div>
          </div>
        </div>
      </section>

      {/* MVV Section */}
      <section className="about-mvv">
        <div className="container">
          <div className="about-mvv__grid">
            <div className="about-mvv__card">
              <div className="about-mvv__icon">
                <FaBullseye />
              </div>
              <h3>OUR MISSION</h3>
              <p>
                Our mission is to offer consumers a variety of high-quality food at reasonable
                prices. We serve meals through both online and offline channels, focusing on local
                traditional recipes rather than mainstream options. Our growth strategy involves
                starting from one city and expanding nationwide, creating a value chain that
                benefits both business and society.
              </p>
            </div>
            <div className="about-mvv__card about-mvv__card--featured">
              <div className="about-mvv__icon">
                <FaEye />
              </div>
              <h3>OUR VISION</h3>
              <p>
                Digirasa aims to be your health partner rather than a food supplier. To
                revolutionize the food industry by providing healthy food and cater the diverse
                culinary tastes missing from the current market. We are committed to delivering
                quality food right to your doorstep, ensuring that every meal meets the highest
                standards of taste and health. Our goal is to set new benchmarks in food preparation
                and delivery, fostering a healthy society and building immunity for future
                generations.
              </p>
            </div>
            <div className="about-mvv__card">
              <div className="about-mvv__icon">
                <FaGem />
              </div>
              <h3>OUR VALUES</h3>
              <p>
                Driven by innovation, collaboration, and quality, we focus on delivering efficient
                solutions with excellence. We believe in transparency and integrity in everything we
                do - from sourcing ingredients to serving our customers. Every decision we make is
                rooted in our commitment to building a healthier, happier community.
              </p>
            </div>
          </div>
        </div>
      </section>

      <AppDownloadSection />
    </div>
  );
};

export default About;
